import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MarketingLayout } from '@byscott-io/corebyscott';
import { portalApi } from '../../api/portal';

// Magic-link sign-in for approved affiliates (#612), in marketing chrome.
export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const expired =
    typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).get('login_error');

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await portalApi.requestLink(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong — please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <MarketingLayout>
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="bg-white rounded-lg shadow p-8">
          <h1 className="text-2xl font-bold mb-1">Sign in</h1>
          <p className="text-gray-500 mb-6">
            We&apos;ll email you a one-time sign-in link — no password needed.
          </p>

          {expired && !sent && (
            <div className="bg-amber-50 border border-amber-200 text-amber-800 px-4 py-3 rounded mb-4 text-sm">
              That sign-in link was invalid or expired. Request a new one below.
            </div>
          )}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4 text-sm">
              {error}
            </div>
          )}

          {sent ? (
            <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded">
              If that email belongs to an approved affiliate, a sign-in link is on
              its way. Check your inbox.
            </div>
          ) : (
            <form onSubmit={submit}>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full border border-gray-300 rounded-lg px-3 py-2 mb-4"
                placeholder="you@example.com"
              />
              <button
                type="submit"
                disabled={submitting || !email}
                className="w-full bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 disabled:opacity-50"
              >
                {submitting ? 'Sending…' : 'Email me a sign-in link'}
              </button>
            </form>
          )}

          <p className="mt-6 text-center text-sm text-gray-500">
            Not an affiliate yet?{' '}
            <Link to="/signup" className="text-indigo-600 hover:text-indigo-800">
              Apply
            </Link>
          </p>
        </div>
      </div>
    </MarketingLayout>
  );
}
